function startFlashOffer() {

  const popup = document.getElementById('flash-offer-popup');

  if (!popup) return;

  const today = new Date().toDateString();

  const alreadyShown =
    localStorage.getItem('flash_offer_date');

  if (alreadyShown === today) {
    return;
  }

  localStorage.setItem(
    'flash_offer_date',
    today
  );

  popup.style.display = 'flex';

  const cartOffer =
document.getElementById(
'flash-cart-offer'
);

if(cartOffer){
cartOffer.style.display='flex';
}

  let timeLeft = 120;

const timer =
document.getElementById(
'flash-timer'
);

const cartTimer =
document.getElementById(
'flash-cart-timer'
);

  const interval = setInterval(() => {

    const minutes =
      Math.floor(timeLeft / 60);

    const seconds =
      timeLeft % 60;

    const timeText =
`${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;

if(timer){
timer.innerHTML = timeText;
}

if(cartTimer){
cartTimer.innerHTML = timeText;
}

    if (timeLeft <= 0) {

      clearInterval(interval);

      popup.style.display = 'none';

    }

    timeLeft--;

  }, 1000);

}

/* Close Button */

document.addEventListener('click', function(e){

  if(e.target.classList.contains('flash-close')){

    document.getElementById(
      'flash-offer-popup'
    ).style.display = 'none';

  }

});

/* Copy Coupon */

document.addEventListener('click', function(e){

  if(e.target.id === 'flash-copy-btn'){

    navigator.clipboard.writeText(
      'FLASH50'
    );

    e.target.innerHTML = 'Copied ✓';

  }

});



document.addEventListener('click', function(e){

if(e.target.id === 'flash-cart-copy'){

navigator.clipboard.writeText(
'FLASH50'
);

e.target.innerHTML='Copied';

}

});



function openNotifyPopup(){
  document
    .getElementById('notify-popup')
    .classList.add('active');
}

document.addEventListener('click',function(e){

  if(e.target.classList.contains('notify-close')){
    document
      .getElementById('notify-popup')
      .classList.remove('active');
  }

});